import ElTreeV2 from "./VTree/index";

const virtualComponentV2 = [ElTreeV2];

const install = (Vue) => {
  virtualComponentV2.forEach((comp) => {
    Vue.component(comp.name, comp);
  });
};

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export default {
  install,
  ElTreeV2,
};
